import React, { useState, useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';

const Information = ({ tooltipText }) => {
  const [isSmallScreen, setIsSmallScreen] = useState(false);
  const [tooltipVisible, setTooltipVisible] = useState(false);
  const tooltipRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 640);
    };

    handleResize(); // Check screen size on component mount
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const handleMouseEnter = () => {
    if (!isSmallScreen) {
      setTooltipVisible(true);
      adjustTooltipPosition();
    }
  };

  const handleMouseLeave = () => {
    if (!isSmallScreen) {
      setTooltipVisible(false);
    }
  };

  const handleTouchOrClick = () => {
    if (isSmallScreen) {
      setTooltipVisible(!tooltipVisible);
      adjustTooltipPosition();
    }
  };

  const adjustTooltipPosition = () => {
    const tooltip = tooltipRef.current;
    // const container = containerRef.current;
    if (tooltip) {
      const tooltipRect = tooltip.getBoundingClientRect();
      // const containerRect = container.getBoundingClientRect();
      const margin = 10; // Margin from window edges
  
      // Ensure the tooltip is always above the dropdown
      tooltip.style.top = 'auto';
      // tooltip.style.bottom = `${containerRect.height}px`; // Position above the dropdown
  
      // Check for horizontal overflow and adjust
      if (tooltipRect.right > window.innerWidth - margin) {
        tooltip.style.left = 'auto';
        tooltip.style.right = `${margin}px`;
        tooltip.style.transform = 'translateX(0)';
      } else if (tooltipRect.left < margin) {
        tooltip.style.left = `${margin}px`;
        tooltip.style.right = 'auto';
        tooltip.style.transform = 'translateX(0)';
      } else {
        tooltip.style.left = '50%';
        tooltip.style.right = 'auto';
        tooltip.style.transform = 'translateX(-50%)';
      }
    }
  };

  return (
    <div
      className="info-container relative flex items-center"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {isSmallScreen ? (
        <button
          onClick={handleTouchOrClick}
          className="info-icon-button cursor-pointer text-blue-700"
        >
          <FontAwesomeIcon icon={faInfoCircle} className="pt-2" />
        </button>
      ) : (
        <div className="relative">
          <FontAwesomeIcon
            icon={faInfoCircle}
            className="info-icon cursor-pointer text-blue-700 pt-2"
          />
        </div>
      )}

<div
          ref={tooltipRef}
          className="tooltip-text absolute bg-gray-400 text-sm font-bold shadow-sm text-black text-center rounded-md py-1.5 px-3 transition-opacity duration-300 opacity-100 visible"
          style={{
            left: '50%', // Center tooltip horizontally
            maxWidth: '200px', // Restricts tooltip width
            wordWrap: 'break-word', // Ensures long words break
            whiteSpace: 'normal', // Allows multi-line text
            padding: '0.5rem', // Padding for better readability
            zIndex: 1000, // Makes sure tooltip is on top
            boxSizing: 'border-box', // Prevents width issues
          }}
        >
          {tooltipText}
        </div>
    </div>
  );
};

export default Information;
